<div class="card pb-4 flex-shrink">
  <p-menubar [model]="items" class="w-full">
    <ng-template #start>
      <img src="assets/planify-logo-white.svg" alt="Logo" class="h-8 w-8" />
      <p class="mr-4">PLANIFY</p>
    </ng-template>
    <!-- Template de fin pour le bouton de déconnexion -->
    <ng-template #end>
      <button
        pButton
        type="button"
        label="Déconnexion"
        icon="pi pi-sign-out"
        class="p-button-secondary"
        (click)="logout()"
      ></button>
    </ng-template>
    <ng-template #item let-item>
      <!-- Cas avec lien -->
      <ng-container *ngIf="item.path; else clickOnly">
        <a
          *ngIf="item.newTab; else internalLink"
          [href]="item.path"
          [attr.target]="'_blank'"
          rel="noopener noreferrer"
          pRipple
          (click)="item.click?.(); activeLabel = item.label"
          [class.active]="activeLabel === item.label"
          class="flex align-items-center p-menubar-item-link"
        >
          <span [class]="item.icon"></span>
          <span class="ml-2">{{ item.label }}</span>
        </a>

        <ng-template #internalLink>
          <a
            [routerLink]="item.path"
            pRipple
            (click)="item.click?.(); activeLabel = item.label"
            [class.active]="activeLabel === item.label"
            class="flex align-items-center p-menubar-item-link"
          >
            <span [class]="item.icon"></span>
            <span class="ml-2">{{ item.label }}</span>
          </a>
        </ng-template>
      </ng-container>

      <!-- Cas sans path, juste un bouton -->
      <ng-template #clickOnly>
        <a
          pRipple
          class="flex align-items-center p-menubar-item-link"
          (click)="item.click?.()"
        >
          <span [class]="item.icon"></span>
          <span class="ml-2">{{ item.label }}</span>
        </a>
      </ng-template>
    </ng-template>
  </p-menubar>
</div>

<div class="flex flex-1 p-2 overflow-y-auto">
  <router-outlet></router-outlet>
</div>
